
import { useEffect } from 'react';
import { Splash } from '@client/shared/design/Splash.tsx';
import { useNavigate } from './router.tsx';

export interface RedirectProps {
  to: string;
  /** Replace the current history entry instead of pushing a new one. Ignored when `external`. */
  replace?: boolean;
  /** Leave the SPA via a full-page navigation (`window.location.assign`): for entries off the
   *  client router, e.g. the separately-bundled internal console. */
  external?: boolean;
  label?: string;
}

/** Declarative redirect: render it and the effect navigates, showing a splash meanwhile. */
export function Redirect({ to, replace = false, external = false, label }: RedirectProps) {
  const navigate = useNavigate();
  useEffect(() => {
    if (external) {
      window.location.assign(to);
      return;
    }
    navigate(to, { replace });
  }, [navigate, to, replace, external]);
  return <Splash label={label} />;
}
